module.exports = __webpack_public_path__ + "images/marketing/home_hero1.jpg";